export default __webpack_public_path__ + "static/media/icon-ic-apple.5082dc69.svg";